/**
 * Función para cargar un script en el head
 */

export function loadScript(scriptSrc) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = scriptSrc
  document.head.appendChild(script)
}
